module.exports = __webpack_public_path__ + "img/80b456d.png";